export * from '@bluelovers/axios-util';
import { dotValue } from '@bluelovers/axios-util';

export default dotValue
